<template>
	<div class="layer-project" data-project-name="lotte-aa">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="award18"></span>LOTTE
						<span class="ib">Auto Auction</span>
					</h1>
					<a href="http://www.lotteautoauction.net" class="link" target="_blank"
						>www.lotteautoauction.net</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						국내 No. 1 자동차 경매장인 롯데오토옥션의 웹 및 모바일 사이트를
						구축했습니다. <br />롯데렌터카의 기본 디자인 가이드에 맞추어
						제작하여 롯데렌터카의 브랜드 이미지를 유지하였습니다. <br />사용자
						중심의 설계 및 디자인에 주안점을 두고 사이트를 구축하여 사이트
						사용성 향상 및 디자인을 리뉴얼했습니다. <br />브랜드 강화를 위한
						컬러 베리에이션 및 엘리먼트 제작을 통해 사용자에게 브랜드 가치를
						전달하고자 하였습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram">
							<li class="item01">Branding <br />Value</li>
							<li class="item02">
								Lotte <br />Auto Auction <br />Design Guide
							</li>
							<li class="item03">User <br />Interface</li>
						</ul>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="pc-web-info">
						<strong class="project-subtit">PC Web</strong>
						<p class="sub-text">
							전체적으로 Full Page로 구성하여 키 비주얼과 중요 콘텐츠를 스크롤을
							통해 볼 수 있는 구조로 구성했습니다. <br />상단에 키 비주얼을 두
							가지로 구성하여 시각적인 요소를 보여주고 하단 중요 콘텐츠 구성
							역시 마우스 오버 및 스크롤 등을 유도하여 인터렉션 효과를 주어
							시각적인 효과를 보여주었습니다.
						</p>
					</div>
					<div class="pc-web-top img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lotte-aa/pc-web-img@m.png"
						/>
					</div>
					<!-- Swiper -->
					<div class="pc-web-slider swiper-container">
						<ul class="swiper-wrapper clfix">
							<li class="swiper-slide item01">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-aa/pc-web-img-01@m.png"
								/>
							</li>
							<li class="swiper-slide item02">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-aa/pc-web-img-02@m.png"
								/>
							</li>
							<li class="swiper-slide item03">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-aa/pc-web-img-03@m.png"
								/>
							</li>
							<li class="swiper-slide item04">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-aa/pc-web-img-04@m.png"
								/>
							</li>
						</ul>

						<!-- Add Pagination -->
						<div class="swiper-pagination pc-web-pagination"></div>
					</div>
				</div>
			</section>
			<section class="section full section02">
				<div class="inner-section">
					<div class="mobile-web-info">
						<strong class="project-subtit">Mobile Web</strong>
						<div class="mobile-text">Lotte Auto Auction <br />No.1</div>
					</div>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/lotte-aa/mobile-web-img@m.png"
						/>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section">
					<div class="point-icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lotte-aa/point-icon@m.png"
							/>
						</div>
					</div>
					<div class="point-color-area">
						<ul>
							<li class="item01"><span>#f04040</span></li>
							<li class="item02"><span>#38414a</span></li>
							<li class="item03"><span>#666666</span></li>
							<li class="item04"><span>#93a2b3</span></li>
							<li class="item05"><span>#a8aaad</span></li>
							<li class="item06"><span>#eeeeee</span></li>
						</ul>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">LOTTE Auto Auction</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".pc-web-slider", {
					spaceBetween: 30,
					pagination: {
						el: ".pc-web-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}
		$window.on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.sub-text {
	word-break: keep-all;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Project Visual, Project CI */
.project-client {
	background: #eeeeee url(/static/img/project-detail/lotte-aa/ci.png) 50% / auto
		17.5px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-aa/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-aa/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 25.5px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-aa/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 51px;
	}
}

/* Overview */
.project-overview {
	background-color: #38414a;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview-diagram li {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 110px;
	height: 110px;
	margin: 0 auto;
	border-radius: 50%;
	text-align: center;
	background-color: #fff;
	color: #222;
}
.project-overview-diagram li + li {
	margin-top: 40px;
}
.project-overview-diagram li + li:before {
	content: "";
	position: absolute;
	top: -30px;
	left: 50%;
	width: 1px;
	height: 20px;
	background-color: #fff;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 25px;
	}
	.project-overview-diagram ul {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.project-overview-diagram li {
		width: 135px;
		height: 135px;
		margin: 0;
	}
	.project-overview-diagram li + li {
		margin-top: 0;
		margin-left: 85px;
	}
	.project-overview-diagram li + li:before {
		top: 50%;
		left: -65px;
		width: 45px;
		height: 1px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-bottom: 60px;
	}
	.project-overview-txt {
		margin-bottom: 50px;
	}
	.project-overview-diagram li {
		width: 200px;
		height: 200px;
		font-size: 20px;
		line-height: 30px;
	}
	.project-overview-diagram li + li {
		margin-top: 0;
		margin-left: 164px;
	}
	.project-overview-diagram li + li:before {
		top: calc(50% - 1px);
		left: -126px;
		width: 90px;
		height: 2px;
	}
}

.section.section01 {
	position: relative;
	padding-bottom: 0;
	background-color: #e9e9e9;
	color: #fff;
}
.section01:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 94.0625vw;
	background-color: #f04040;
}
.section01:after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 42.5vw;
	background-color: #38414b;
}
.section01 .inner-section {
	position: relative;
}
.pc-web-info {
	margin-bottom: 30px;
	padding: 0 15px;
}
.pc-web-top {
	padding-right: 15px;
}
.pc-web-slider {
	padding-left: 30px;
	padding-right: 30px;
	padding-bottom: 37px;
}
.pc-web-slider img {
	box-shadow: 0 6px 31px rgba(0, 0, 0, 0.13);
}
@media screen and (max-width: 711px) {
	.section01 .project-subtit {
		font-size: 2rem;
	}
}
@media screen and (min-width: 712px) {
	.section01:before {
		height: 45.9971vw;
	}
	.section01:after {
		height: 25.1404vw;
	}
	.pc-web-top {
		margin-bottom: 50px;
	}
	.pc-web-info {
		margin-bottom: 30px;
		padding: 0 40px;
	}
	.pc-web-top {
		padding-left: 40px;
		padding-right: 80px;
	}
	.pc-web-slider {
		padding: 0 12.0786vw;
	}
	.pc-web-slider .swiper-wrapper {
		display: block;
	}
	.pc-web-slider li {
		float: left;
		width: 36.3061vw;
	}
	.pc-web-slider li:nth-child(odd) {
		float: right;
	}
	.pc-web-slider .item01 {
		margin-bottom: 2.528vw;
	}
	.pc-web-slider .item02 {
		margin-top: 13.8342vw;
		margin-bottom: 2.528vw;
	}
}
@media screen and (min-width: 1280px) {
	.section01:before {
		height: 634px;
	}
	.section01:after {
		height: 359px;
	}
	.section01 .inner-section {
		padding-top: 80px;
	}
	.pc-web-info {
		max-width: 1280px;
		margin: 0 auto 120px;
		padding: 0 20px;
	}
	.pc-web-info .sub-text {
		font-size: 16px;
		line-height: 1.8;
	}
	.pc-web-top {
		max-width: 1280px;
		margin: 0 auto 130px;
		padding: 0 20px;
		text-align: center;
	}
	.pc-web-slider {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 100px;
	}
	.pc-web-slider li {
		width: 518px;
	}
	.pc-web-slider .item01 {
		margin-bottom: 36px;
	}
	.pc-web-slider .item02 {
		margin-top: 197px;
		margin-bottom: 36px;
	}
}

.section.full.section02 {
	position: relative;
	padding-bottom: 0;
	color: #fff;
}
.section02:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: calc(100vw * (317 / 640) + 150px);
	background-color: #38414b;
}
.section02 .inner-section {
	position: relative;
}
.mobile-text {
	font-size: 2.9rem;
	line-height: 3.1rem;
	letter-spacing: -0.04em;
	text-transform: uppercase;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.05);
}
@media screen and (max-width: 711px) {
	.section02 .project-subtit {
		margin-bottom: 5px;
		font-size: 2rem;
	}
	.section02 .mobile-web-info {
		margin-bottom: 10px;
		padding: 0 15px;
	}
}
@media screen and (min-width: 712px) {
	.section02 .inner-section {
		padding-top: 20px;
	}
	.section02:before {
		height: calc(100vw * (411 / 1424) + 260px);
	}
	.section02 .mobile-web-info {
		margin-bottom: 0;
		padding: 0 40px;
	}
	.mobile-text {
		font-size: 6rem;
		line-height: 6.5rem;
	}
}
@media screen and (min-width: 1280px) {
	.section02:before {
		height: calc(100vw * (550 / 1920) + 530px);
	}
	.section02 .inner-section {
		padding-top: 70px;
	}
	.section02 .project-subtit {
		margin-bottom: 60px;
	}
	.section02 .mobile-web-info {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 20px;
	}
	.mobile-text {
		font-size: 120px;
		line-height: 130px;
	}
}
@media screen and (min-width: 1920px) {
	.section02:before {
		height: 1080px;
	}
}

.section.section03 {
	padding-top: 30px;
}
.point-icon-area {
	margin-bottom: 15px;
}
.point-icon-area .img {
	width: 71.40625vw;
	margin: 0 auto;
}
.point-color-area ul {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 0 auto;
}
.point-color-area li {
	position: relative;
	margin: 25px 0;
	padding-top: 56px;
	font-weight: 500;
}
.point-color-area li:before {
	content: "";
	position: absolute;
	top: 0;
	left: 50%;
	width: 46px;
	height: 46px;
	border-radius: 50%;
	transform: translateX(-50%);
}
.point-color-area .item01:before {
	background-color: #f04040;
}
.point-color-area .item02:before {
	background-color: #38414a;
}
.point-color-area .item03:before {
	background-color: #666666;
}
.point-color-area .item04:before {
	background-color: #93a2b3;
}
.point-color-area .item05:before {
	background-color: #a8aaad;
}
.point-color-area .item06:before {
	background-color: #eeeeee;
}
@media screen and (max-width: 711px) {
	.point-color-area ul {
		width: 71.40625vw;
	}
	.point-color-area .item02,
	.point-color-area .item05 {
		width: calc(100% - 110px);
		text-align: center;
	}
}
@media screen and (min-width: 712px) {
	.section03 .inner-section {
		padding-bottom: 40px;
	}
	.point-icon-area {
		margin-bottom: 43px;
	}
	.point-icon-area .img {
		width: 72.3314vw;
	}
	.point-color-area ul {
		width: 72.3314vw;
	}
	.point-color-area li {
		width: 55px;
		margin-top: 0;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		padding-top: 100px;
		padding-bottom: 100px;
	}
	.point-icon-area {
		margin-bottom: 94px;
	}
	.point-icon-area .img {
		width: auto;
	}
	.point-color-area ul {
		width: 1240px;
	}
	.point-color-area li {
		position: relative;
		width: 92px;
		margin: 0;
		padding-top: 102px;
		font-size: 16px;
		text-align: center;
	}
	.point-color-area li:before {
		width: 92px;
		height: 92px;
	}
	.point-color-area li span {
		letter-spacing: 0.05em;
	}
}
</style>


// WEBPACK FOOTER //
// src/projects/lotte-aa.vue